<div class="cancellation-tab">
  <div class="cancellation-tab__intro">
    <h2 class="cancellation-tab__title">Cancellation &amp; refund</h2>
    <p class="cancellation-tab__description">
      Lets this company's attendants cancel memberships, prepaid books, single washes and add-ons,
      and refund completed purchases, from Orders, the Active Membership pop-up and the Customers
      tabs. Turn it on for the whole company or only for some of its locations, and choose whether
      prorated refunds are offered.
    </p>
  </div>

  <div class="cancellation-tab__state" *ngIf="!source">Loading company…</div>

  <div class="cancellation-tab__card" *ngIf="source">
    <app-cancellation-settings [isActive]="true" [source]="source"></app-cancellation-settings>
  </div>
</div>
